import React, { useEffect, useState } from 'react';
import {
	BrowserRouter as Router,
	Route,
	Routes,
	Navigate,
} from 'react-router-dom';
import Login from './app/main/accounts/login/Login';
import Signup from './app/main/accounts/signup/Signup';
import ForgotPassword from './app/main/accounts/forgotPassword/ForgotPassword';
import VerificationCode from './app/main/accounts/verificationcode/VerificatonCode';
import ContactUs from './app/main/accounts/contactUs/ContactUs';
import Feedback from './app/main/accounts/feedback/Feedback';
import AboutUs from './app/main/accounts/aboutUs/AboutUs';
import SelectPractice from './app/main/accounts/selectPractice/SelectPractice';
import PatientList from './app/main/patients/patient_List/PatientList';
import Batches from './app/main/batches/Batches';
import SideBar from './app/layouts/sidebar/SideBar';
import Settings from './app/main/dashboard/settings/Settings';
import ScheduleAppointment from './app/main/dashboard/scheduleAppointmets/scheduleAppointment';
import { Dashboard } from './app/main/dashboard/Dashboard';
import { EditCharge } from './app/main/charges/EditCharge';
import { NewCharge } from './app/main/charges/NewCharge';
import { ChargesList } from './app/main/charges/ChargesList';
import RolesPermission from './app/main/dashboard/rolesPermissions/RolesPermissions';
import MissedChargeFinder from './app/main/dashboard/missedCharge/MissedChargeFinder';
import authService from '../src/app/services/authService/authService';
import PatientReport from './app/main/Reports/PatientReport';
import NewPatient from './app/main/patients/new_patient/NewPatient';
import EditPatient from './app/main/patients/edit_patient/EditPatient';
import SettingsV2 from './app/main/settingsV2/SettingsV2';
import SelectPracticev2 from './app/main/accounts/selectPractice/SelectPracticev2';
import Navbar from './app/layouts/sidebar/Navbar';
import ScheduleAppointmentMain from './app/main/dashboard/scheduleAppointmets/scheduleAppointmentMain';
import { useStateValue } from './app/services/state/State';

function AppRoutes() {
	// useEffect(() => {
	// 	authService.handleRefresh();
	// }, []);
	const [{ user }, dispatch] = useStateValue();
	// Function to check if the user is authenticated
	const token = user?.token || localStorage.getItem('accessToken');
	// const [token, settoken] = useState(false);
	// useEffect(() => {
	// 	if (token) settoken(true);
	// }, [token]);
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			<Route path="/signup" element={<Signup />} />
			<Route path="/forgotPassword" element={<ForgotPassword />} />
			<Route path="/verification" element={<VerificationCode />} />
			<Route path="/contactUs" element={<ContactUs />} />
			<Route path="/feedback" element={<Feedback />} />
			<Route path="/aboutUs" element={<AboutUs />} />
			<Route
				path="/selectPractice"
				element={token ? <SelectPracticev2 /> : <Navigate to="/" replace />}
			/>
			<Route element={<SideBar />}>
				<Route
					path="/dashboard"
					element={token ? <Dashboard /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/patient_list"
					element={token ? <PatientList /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/Add_Patient"
					element={token ? <NewPatient /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/Edit_Patient"
					element={token ? <EditPatient /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/charges"
					element={token ? <ChargesList /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/editCharge"
					element={token ? <EditCharge /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/newCharge"
					element={token ? <NewCharge /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/batches"
					element={token ? <Batches /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/schedular"
					element={
						token ? <ScheduleAppointmentMain /> : <Navigate to="/" replace />
					}
				/>
				<Route
					path="/messages"
					element={token ? <h2>Messages</h2> : <Navigate to="/" replace />}
				/>
				<Route
					path="/reports"
					element={token ? <PatientReport /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/roles"
					element={token ? <RolesPermission /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/missed_charge_finder"
					element={token ? <MissedChargeFinder /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/user"
					element={token ? <h2>User is here</h2> : <Navigate to="/" replace />}
				/>
				<Route
					path="/settings"
					element={token ? <Settings /> : <Navigate to="/" replace />}
				/>
				<Route
					path="/settingV2"
					element={token ? <SettingsV2 /> : <Navigate to="/" replace />}
				/>
			</Route>
		</Routes>
	);
}

export default AppRoutes;
